export interface DeliveryMetrics {
  DATA_RECEIVED: string;
  NO_DATA_RECEIVED: string;
  SERVER_ERROR: string;
  ZIPCODE_MISMATCH: string;
}

export interface ProofOfDeliveryMetrics extends DeliveryMetrics {
  DISPLAY_SUCCESS: string;
  DISPLAY_FAILURE: string;
}

const createDeliveryMetrics = (prefix: string): DeliveryMetrics => ({
  DATA_RECEIVED: `${prefix}DataReceived`,
  NO_DATA_RECEIVED: `${prefix}NoDataReceived`,
  SERVER_ERROR: `${prefix}ServerError`,
  ZIPCODE_MISMATCH: `${prefix}ZipCodeMismatch`,
});

export const POD_METRICS: ProofOfDeliveryMetrics = {
  ...createDeliveryMetrics('ProofOfDelivery'),
  DISPLAY_SUCCESS: 'ProofOfDeliveryDisplaySuccess',
  DISPLAY_FAILURE: 'ProofOfDeliveryDisplayFailure',
};

export const SOD_METRICS: DeliveryMetrics = createDeliveryMetrics('SignatureOnDelivery');

export const RECIPIENT_METRICS: DeliveryMetrics = createDeliveryMetrics('RecipientInformation');
